goog.provide("shadow.js.shim.module$parinfer_codemirror");
goog.provide("module$shadow_js_shim_module$parinfer_codemirror");
shadow.js.shim.module$parinfer_codemirror = require("parinfer-codemirror");
module$shadow_js_shim_module$parinfer_codemirror.default = shadow.js.shim.module$parinfer_codemirror;
